// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.13585"][{"1936":0}[chunkId]] || "1.13586") + "/" + chunkId + ".js";
};